/**
 * Jersey binds limit to Integer. The literal "totalRecords" is a 404.
 * Use the known count, otherwise a numeric page large enough for one entity's relations.
 */
export function relationListLimit(totalRecords: number): number {
  if (typeof totalRecords === 'number' && totalRecords > 0) {
    return totalRecords;
  }
  return 10000;
}

export function relationsNamed<T extends { name?: string }>(relations: T[], search: string): T[] {
  const rows = relations || [];
  const needle = (search || '').trim().toLowerCase();
  if (!needle) {
    return rows;
  }
  return rows.filter(rel => rel && rel.name && rel.name.toLowerCase().indexOf(needle) >= 0);
}



// WEBPACK FOOTER //
// ./src/app/entities/relations/relation-list.util.ts